import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import {
  ContactSection,
  CardsSection,
  MediaSection,
  TopicsSection,
  UpdatesSection,
  IndexSection,
} from '@/pages/home/components/ContentSectionsA';
import {
  AppSection,
  CommentsSection,
  RankingSection,
  AboutSection,
  CarouselSection,
  FeaturesSection,
  FaqSection,
} from '@/pages/home/components/ContentSectionsB';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <CardsSection />
        <MediaSection />
        <TopicsSection />
        <UpdatesSection />
        <IndexSection />
        <AppSection />
        <CommentsSection />
        <RankingSection />
        <AboutSection />
        <CarouselSection />
        <FeaturesSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}